import React from 'react'
import { Typography, Box, Grid, Chip, Button } from '@mui/material'
import moment from 'moment'
import { STATUS_COLOR_MAP } from '../../../../../constant/status'

const Detail = ({ data }) => {
  return (
    <Box p={2}>
      <Grid container spacing={4} mb={4}>
        {/* General detail */}
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Status</Typography>
          <Box mt={1}>
            <Chip
              label={data.status}
              color={STATUS_COLOR_MAP[data.status]}
              size='small'
              style={{ fontWeight: 900 }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Phone</Typography>
          <Typography variant='h6'>{data.phone}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Serial Number</Typography>
          <Typography variant='h6'>{data.serialNumber}</Typography>
        </Grid>

        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Type</Typography>
          <Typography variant='h6'>{data.type}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Brand</Typography>
          <Typography variant='h6'>{data.brand}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>State</Typography>
          <Typography variant='h6'>{data.state}</Typography>
        </Grid>

        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Workshop</Typography>
          <Typography variant='h6'>{data.workshop}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Email</Typography>
          <Typography variant='h6'>{data.email ?? 'N/A'}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>TnG Code</Typography>
          <Typography variant='h6'>{data.tngCode ?? 'N/A'}</Typography>
        </Grid>

        {/* Meta */}
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Created At</Typography>
          <Typography variant='h6'>
            {moment(data?.createdAt).format('YYYY-MM-DD h:mm a')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <Typography variant='h4'>Last Update</Typography>
          <Typography variant='h6'>
            {moment(data?.updatedAt).format('YYYY-MM-DD h:mm a')}
          </Typography>
        </Grid>
      </Grid>
      {/* Message */}
      <Grid container spacing={4} mb={4}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant='h4'>Reject Reason</Typography>
          <Box style={{ marginRight: '15%', marginLeft: '15%' }}>
            <Typography variant='h6'>{data.rejectReason ?? 'N/A'}</Typography>
          </Box>
        </Grid>
      </Grid>
      {/* Uploaded Images */}
      <Grid container spacing={4} mb={4}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant='h2'>Receipt/Invoice Photo: </Typography>
          <img src={`${data.batteryInvoice.uploadPath}`} height='auto' width='100%' alt={''} />
          <Button
            color='primary'
            href={`${data.batteryInvoice.uploadPath}`}
            target='_blank'
            rel='noopener noreferrer'
            sx={{ textTransform: 'none', textDecoration: 'underline' }}
          >
            Not showing? Click here.
          </Button>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant='h2'>Battery Photo: </Typography>
          <img src={`${data.batteryPhoto.uploadPath}`} height='auto' width='100%' alt={''} />
          <Button
            color='primary'
            href={`${data.batteryPhoto.uploadPath}`}
            target='_blank'
            rel='noopener noreferrer'
            sx={{ textTransform: 'none', textDecoration: 'underline' }}
          >
            Not showing? Click here.
          </Button>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant='h2'>Scratch Card Photo: </Typography>
          <img src={`${data.scratchCardPhoto.uploadPath}`} height='auto' width='100%' alt={''} />
          <Button
            color='primary'
            href={`${data.scratchCardPhoto.uploadPath}`}
            target='_blank'
            rel='noopener noreferrer'
            sx={{ textTransform: 'none', textDecoration: 'underline' }}
          >
            Not showing? Click here.
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Detail
